import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const Staff = () => {
    const [staff, setStaff] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedRole, setSelectedRole] = useState('all');

    // Mock data for staff
    useEffect(() => {
        // Simulate loading staff data
        setTimeout(() => {
            setStaff([
                {
                    id: 1,
                    name: 'Maria Ionescu',
                    email: 'maria.ionescu@evoomedical.ro',
                    phone: '+40 21 567 8901',
                    role: 'Asistent Medical',
                    department: 'Consultații Generala',
                    hireDate: '2020-03-15',
                    status: 'active'
                },
                {
                    id: 2,
                    name: 'Alexandru Georgescu',
                    email: 'alexandru.georgescu@evoomedical.ro',
                    phone: '+40 21 678 9012',
                    role: 'Receptioner',
                    department: 'Recepție',
                    hireDate: '2019-11-20',
                    status: 'active'
                },
                {
                    id: 3,
                    name: 'Simona Dumitrache',
                    email: 'simona.dumitrache@evoomedical.ro',
                    phone: '+40 21 789 0123',
                    role: 'Laborant',
                    department: 'Laborator',
                    hireDate: '2021-07-10',
                    status: 'active'
                },
                {
                    id: 4,
                    name: 'Cristian Vlad',
                    email: 'cristian.vlad@evoomedical.ro',
                    phone: '+40 21 890 1234',
                    role: 'Administrator Sistem',
                    department: 'IT',
                    hireDate: '2018-05-08',
                    status: 'on_leave'
                },
                {
                    id: 5,
                    name: 'Diana Stoica',
                    email: 'diana.stoica@evoomedical.ro',
                    phone: '+40 21 901 2345',
                    role: 'Specialist Resurse Umane',
                    department: 'HR',
                    hireDate: '2022-01-15',
                    status: 'active'
                }
            ]);
            setLoading(false);
        }, 1000);
    }, []);

    const roles = ['all', 'Asistent Medical', 'Receptioner', 'Laborant', 'Administrator Sistem', 'Specialist Resurse Umane', 'Contabil', 'Îngrijitor'];

    const filteredStaff = selectedRole === 'all'
        ? staff
        : staff.filter(member => member.role === selectedRole);

    return (
        <div className="staff-page">
            <div className="page-navigation-header">
                <div className="nav-header-content">
                    <NavLink to="/dashboard" className="back-to-dashboard">
                        ← Înapoi la Dashboard
                    </NavLink>
                    <div className="quick-nav">
                        <NavLink to="/patients" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Pacienți
                        </NavLink>
                        <NavLink to="/appointments" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Programări
                        </NavLink>
                        <NavLink to="/doctors" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Doctori
                        </NavLink>
                    </div>
                </div>
            </div>

            <div className="page-header">
                <h1>Gestionare Personal</h1>
                <p>Administrarea informațiilor despre membrii personalului medical</p>
            </div>

            <div className="controls-section">
                <div className="filter-section">
                    <label htmlFor="role-filter">Filtrează după rol:</label>
                    <select
                        id="role-filter"
                        value={selectedRole}
                        onChange={(e) => setSelectedRole(e.target.value)}
                        className="role-select"
                    >
                        <option value="all">Toate Rolurile</option>
                        {roles.slice(1).map(role => (
                            <option key={role} value={role}>
                                {role}
                            </option>
                        ))}
                    </select>
                </div>
                <button className="add-staff-btn">Adaugă Membru Personal</button>
            </div>

            <div className="staff-stats">
                <div className="stat-card">
                    <h3>Total Personal</h3>
                    <div className="stat-number">{staff.length}</div>
                </div>
                <div className="stat-card">
                    <h3>Activi</h3>
                    <div className="stat-number">{staff.filter(member => member.status === 'active').length}</div>
                </div>
                <div className="stat-card">
                    <h3>În Concediu</h3>
                    <div className="stat-number">{staff.filter(member => member.status === 'on_leave').length}</div>
                </div>
                <div className="stat-card">
                    <h3>Departamente</h3>
                    <div className="stat-number">{[...new Set(staff.map(s => s.department))].length}</div>
                </div>
            </div>

            <div className="staff-table-container">
                {loading ? (
                    <div className="loading">Se încarcă lista personalului...</div>
                ) : (
                    <table className="staff-table">
                        <thead>
                            <tr>
                                <th>Nume</th>
                                <th>Email</th>
                                <th>Telefon</th>
                                <th>Rol</th>
                                <th>Departament</th>
                                <th>Data Angajării</th>
                                <th>Status</th>
                                <th>Acțiuni</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredStaff.map(member => (
                                <tr key={member.id}>
                                    <td>{member.name}</td>
                                    <td>{member.email}</td>
                                    <td>{member.phone}</td>
                                    <td>{member.role}</td>
                                    <td>{member.department}</td>
                                    <td>{new Date(member.hireDate).toLocaleDateString('ro-RO')}</td>
                                    <td>
                                        <span className={`status-badge ${member.status}`}>
                                            {member.status === 'active' ? 'Activ' : 'În Concediu'}
                                        </span>
                                    </td>
                                    <td>
                                        <button className="view-btn">Vezi Detalii</button>
                                        <button className="edit-btn">Editează</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            <style jsx>{`
                .staff-page {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 2rem;
                }

                .page-header {
                    margin-bottom: 2rem;
                }

                .page-header h1 {
                    color: #333;
                    margin-bottom: 0.5rem;
                }

                .page-header p {
                    color: #666;
                }

                .controls-section {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 2rem;
                    gap: 1rem;
                }

                .filter-section {
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                }

                .filter-section label {
                    font-weight: 500;
                    color: #333;
                }

                .role-select {
                    padding: 0.5rem;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    font-size: 1rem;
                    min-width: 200px;
                }

                .add-staff-btn {
                    padding: 0.75rem 1.5rem;
                    background: #667eea;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: 500;
                    transition: background 0.3s;
                }

                .add-staff-btn:hover {
                    background: #5a67d8;
                }

                .staff-stats {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                    gap: 1rem;
                    margin-bottom: 2rem;
                }

                .stat-card {
                    background: white;
                    padding: 1.5rem;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    border-left: 4px solid #667eea;
                }

                .stat-card h3 {
                    margin: 0 0 0.5rem 0;
                    color: #666;
                    font-size: 0.9rem;
                    text-transform: uppercase;
                    font-weight: 600;
                }

                .stat-number {
                    font-size: 2rem;
                    font-weight: bold;
                    color: #333;
                }

                .staff-table-container {
                    background: white;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    overflow-x: auto;
                }

                .loading {
                    text-align: center;
                    padding: 3rem;
                    color: #666;
                }

                .staff-table {
                    width: 100%;
                    border-collapse: collapse;
                    min-width: 1000px;
                }

                .staff-table th,
                .staff-table td {
                    padding: 1rem;
                    text-align: left;
                    border-bottom: 1px solid #f0f0f0;
                }

                .staff-table th {
                    background: #f8f9fa;
                    font-weight: 600;
                    color: #333;
                }

                .staff-table tbody tr:hover {
                    background: #f8f9fa;
                }

                .status-badge {
                    padding: 0.25rem 0.75rem;
                    border-radius: 4px;
                    font-size: 0.8rem;
                    font-weight: 600;
                    text-transform: uppercase;
                }

                .status-badge.active {
                    background: #d4edda;
                    color: #155724;
                }

                .status-badge.on_leave {
                    background: #fff3cd;
                    color: #856404;
                }

                .view-btn,
                .edit-btn {
                    padding: 0.4rem 0.8rem;
                    margin-right: 0.3rem;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: 500;
                    font-size: 0.9rem;
                    transition: background 0.3s;
                }

                .view-btn {
                    background: #28a745;
                    color: white;
                }

                .view-btn:hover {
                    background: #218838;
                }

                .edit-btn {
                    background: #ffc107;
                    color: #212529;
                }

                .edit-btn:hover {
                    background: #e0a800;
                }

            .page-navigation-header {
                background: white;
                border-radius: 8px;
                box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                margin-bottom: 2rem;
                padding: 1rem;
            }

            .nav-header-content {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                gap: 1rem;
            }

            .back-to-dashboard {
                color: #667eea;
                text-decoration: none;
                font-weight: 500;
                padding: 0.5rem 1rem;
                border-radius: 4px;
                transition: background 0.3s;
            }

            .back-to-dashboard:hover {
                background: #f8f9fa;
            }

            .quick-nav {
                display: flex;
                gap: 1rem;
            }

            .quick-nav-link {
                padding: 0.5rem 1rem;
                color: #666;
                text-decoration: none;
                border-radius: 4px;
                font-weight: 500;
                transition: all 0.3s;
            }

            .quick-nav-link:hover, .quick-nav-link.active {
                background: #667eea;
                color: white;
            }

            @media (max-width: 768px) {
                .controls-section {
                    flex-direction: column;
                    align-items: stretch;
                }

                .filter-section {
                    justify-content: center;
                }

                .staff-table-container {
                    margin-bottom: 1rem;
                }

                .nav-header-content {
                    flex-direction: column;
                    align-items: stretch;
                }

                .quick-nav {
                    justify-content: center;
                }
            }
        `}</style>
        </div>
    );
};

export default Staff;
